<template>
  <v-dialog v-model="dialogOpen" max-width="700px">
    <v-card>
      <v-card-title class="tw-mb-5">
        <span>{{ isEditMode ? "แก้ไขข้อมูล AP Kate" : "เพิ่มข้อมูลAP Kate" }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="doclineForm" v-model="valid">
          <v-container>
            <v-row class="py-0">
              <!-- <v-col cols="12" sm="6" class="py-0">
                <v-autocomplete
                  v-model="form.expenseCode"
                  :items="expenseList"
                  :item-text="(exp) => `${exp.expCode} - ${exp.expName}`"
                  item-value="expCode"
                  label="รหัสค่าใช้จ่าย (Expense Code)"
                  :rules="[(v) => !!v || 'กรุณาเลือกรหัสบัญชี']"
                  required
                  dense
                  outlined
                  persistent-placeholder
                ></v-autocomplete>
              </v-col> -->
              <!-- <v-col cols="12" sm="6" class="py-0">
                <v-autocomplete
                  v-model="form.taxCode"
                  :items="vatList"
                  :item-text="(vat) => `${vat.vatCode} - ${vat.vatName}`"
                  item-value="vatCode"
                  label="รหัส VAT (VAT Code)"
                  :rules="[(v) => !!v || 'กรุณาเลือกรหัสภาษี']"
                  required
                  dense
                  outlined
                  persistent-placeholder
                ></v-autocomplete>
              </v-col> -->
            </v-row>
            <v-row class="py-0">
              <v-col cols="12" sm="6" class="py-0">
                <!-- Original code - commented out -->
                <!-- <v-text-field
                  v-model="form.lineTotal"
                  label="เงินเพิ่ม (Net Amount)"
                  type="text"
                  :rules="[
                    (v) => v >= 0 || 'ต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ 0',
                  ]"
                  required
                  dense
                  outlined
                  persistent-placeholder
                ></v-text-field> -->
                <!-- Mock value field -->
                <v-text-field
                  v-model="mockLineTotal"
                  label="เงินเพิ่ม (Net Amount)"
                  type="text"
                  :rules="[
                    (v) => v >= 0 || 'ต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ 0',
                  ]"
                  required
                  dense
                  outlined
                  persistent-placeholder
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <!-- Original code - commented out -->
                <!-- <v-text-field
                  v-model="form.taxAmount"
                  dense
                  outlined
                  label="เบี้ยปรับ (Penalty Amount)"
                  type="text"
                  :rules="[
                    (v) => v >= 0 || 'ต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ 0',
                  ]"
                  persistent-placeholder
                  :append-icon="userManuallyEnteredTaxAmount ? 'mdi-refresh' : ''"
                  @click:append="resetTaxAmountToAuto"
                ></v-text-field> -->
                <!-- Mock value field -->
                <v-text-field
                  v-model="mockTaxAmount"
                  dense
                  outlined
                  label="เบี้ยปรับ (Penalty Amount)"
                  type="text"
                  :rules="[
                    (v) => v >= 0 || 'ต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ 0',
                  ]"
                  persistent-placeholder
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row class="py-0">
              <v-col cols="12" sm="6" class="py-0">
                <v-autocomplete
                  v-model="form.whtCode"
                  :items="whtList"
                  :item-text="
                    (wht) => `${wht.whtCode} - ${wht.whtName} (${wht.whtRate}%)`
                  "
                  item-value="whtCode"
                  label="รหัส WHT (WHT Code)"
                  dense
                  outlined
                  persistent-placeholder
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" class="py-0">
                <v-text-field
                  dense
                  outlined
                  :value="docGrossPrice"
                  label="มูลค่ารวม VAT (Gross Price)"
                  :rules="[
                    (v) => v >= 0 || 'ต้องเป็นตัวเลขที่มากกว่าหรือเท่ากับ 0',
                  ]"
                  type="text"
                  disabled
                  persistent-placeholder
                ></v-text-field>
              </v-col>
            </v-row> -->
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="tw-mb-2">
        <v-spacer></v-spacer>
        <v-btn text @click="cancel" :disabled="isUpdatingVendorDefault" outlined
          >ยกเลิก</v-btn
        >
        <v-btn
          color="blue darken-1"
          @click="save"
          :disabled="!valid"
          class="tw-text-white"
          :loading="isUpdatingVendorDefault"
        >
          <v-icon left>{{ isEditMode ? "mdi-check" : "mdi-plus" }}</v-icon>
          {{ isEditMode ? "ตกลง" : "เพิ่ม" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import fc from "@/firebaseConfig";

export default {
  name: "DoclineFormDialogAPKate",
  props: {
    isOpen: { type: Boolean, default: false },
    docline: { type: Object },
    expenseList: { type: Array, required: true },
    vatList: { type: Array, required: true },
    whtList: { type: Array, required: true },
    isEditMode: { type: Boolean, required: true },
    companyID: { type: String, required: true },
    cardCode: { type: String, required: true },
  },
  computed: {
    dialogOpen: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$emit("update:isOpen", value);
      },
    },
    docGrossPrice() {
      const r = (
        Number(this.form.lineTotal) + Number(this.form.taxAmount || 0)
      )?.toFixed(2);
      return !isNaN(r) ? r : "0.00";
    },
    docTaxAmount() {
      // If tax amount is manually entered, use it; otherwise calculate automatically
      if (this.form.taxAmount !== undefined && this.form.taxAmount !== null && this.form.taxAmount !== "") {
        return Number(this.form.taxAmount);
      }
      const r =
        this.form.taxCode === "P00"
          ? this.form.lineTotal * (0 / 100)
          : Math.round(this.form.lineTotal * 7) / 100;
      return !isNaN(r) ? r : 0;
    },
  },
  data() {
    return {
      isUpdatingVendorDefault: false,
      userManuallyEnteredTaxAmount: false, // Flag to track manual entry
      // Mock values for edit fields
      mockLineTotal: "0.00",
      mockTaxAmount: "0.00",
      form: {
        expenseCode: "",
        expenseName: "",
        acctCode: "",
        acctName: "",
        taxCode: "",
        acctCodeTax: "",
        acctNameTax: "",
        whtName: "",
        taxAmount: "",
        lineTotal: 0,
        grossPrice: 0,
        whtCode: "",
        whtAcctCode: "",
        whtRate: 0,
        whtAmount: 0,
      },
      valid: false,
    };
  },
  watch: {
    docline: {
      immediate: true,
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          this.form = { ...newVal };
          // Ensure taxAmount is a number for consistency
          if (this.form.taxAmount !== undefined && this.form.taxAmount !== null && this.form.taxAmount !== "") {
            this.form.taxAmount = Number(this.form.taxAmount);
          }
          // Reset the flag when loading existing data
          this.userManuallyEnteredTaxAmount = false;
          // Set mock values from docline data if available, otherwise use 0.00
          this.mockLineTotal = newVal.lineTotal ? String(Number(newVal.lineTotal).toFixed(2)) : "0.00";
          this.mockTaxAmount = newVal.taxAmount ? String(Number(newVal.taxAmount).toFixed(2)) : "0.00";
        } else {
          this.resetForm();
        }
      },
    },
    "form.whtCode"(newValue) {
      this.form.whtRate =
        this.whtList.find((x) => x?.whtCode === newValue)?.whtRate || "";
        this.form.whtAcctCode =
        this.whtList.find((x) => x?.whtCode === newValue)?.acctCode || "";
    },
    "form.lineTotal"() {
      // Always recalculate tax amount when line total changes, unless user manually entered one
      if (!this.userManuallyEnteredTaxAmount) {
        this.form.taxAmount = this.calculateTaxAmount();
      }
    },
    "form.taxCode"() {
      // Always recalculate tax amount when tax code changes, unless user manually entered one
      if (!this.userManuallyEnteredTaxAmount) {
        this.form.taxAmount = this.calculateTaxAmount();
      }
    },
    "form.taxAmount"() {
      // If user clears the tax amount field, reset the flag and auto-calculate
      if (this.form.taxAmount === undefined || this.form.taxAmount === null || this.form.taxAmount === "") {
        this.userManuallyEnteredTaxAmount = false;
        this.form.taxAmount = this.calculateTaxAmount();
      } else {
        // User has entered a value, mark as manually entered
        this.userManuallyEnteredTaxAmount = true;
      }
    },
  },
  methods: {
    calculateTaxAmount() {
      const r =
        this.form.taxCode === "P00"
          ? this.form.lineTotal * (0 / 100)
          : Math.round(this.form.lineTotal * 7) / 100;
      return !isNaN(r) ? r : 0;
    },
    resetTaxAmountToAuto() {
      this.userManuallyEnteredTaxAmount = false;
      this.form.taxAmount = this.calculateTaxAmount();
    },
    resetForm() {
      this.form = {
        expenseCode: "",
        expenseName: "",
        acctCode: "",
        acctType: 0,
        acctTypeWht: 0,
        acctName: "",
        taxCode: "",
        acctCodeTax: "",
        acctNameTax: "",
        whtName: "",
        taxAmount: "",
        lineTotal: 0,
        grossPrice: 0,
        whtCode: "",
        whtAcctCode: "",
        whtAcctName: "",
        whtRate: 0,
        whtAmount: 0,
      };
      this.userManuallyEnteredTaxAmount = false; // Reset the flag
      // Reset mock values to 0.00
      this.mockLineTotal = "0.00";
      this.mockTaxAmount = "0.00";
      this.$refs.doclineForm?.reset();
      this.isUpdatingVendorDefault = false;
    },
    cancel() {
      this.$emit("update:isOpen", false);
      this.resetForm();
    },
    async save() {
      if (this.$refs.doclineForm.validate()) {
        const defaultBlank = {
          expenseCode: "",
          expenseName: "",
          acctCode: "",
          acctType: 0,
          acctTypeWht: 0,
          acctCodeTax: "",
          acctNameTax: "",
          whtName: "",
          acctName: "",
          taxCode: "",
          taxAmount: "",
          lineTotal: 0,
          grossPrice: 0,
          whtCode: "",
          whtAcctCode: "",
          whtAcctName: "",
          whtRate: 0,
          whtAmount: 0,
        };

        const expense = this.expenseList.find(
          (x) => x?.expCode === this.form.expenseCode
        );

        const vat = this.vatList.find((x) => x?.vatCode === this.form.taxCode);
        const wht = this.whtList.find((x) => x?.whtCode === this.form.whtCode);

        this.form.acctName = expense?.acctName || "";
        this.form.acctCode = expense?.acctCode || "";
        this.form.acctType = expense?.tranType || 0;
        this.form.expenseName = expense?.expName || "";
        this.form.acctCodeTax = vat?.acctCode || "";
        this.form.acctNameTax = vat?.acctName || "";
        this.form.acctTypeWht = wht?.tranType || 0;
        this.form.whtName = wht?.whtName || "";
        this.form.whtAcctCode = wht?.acctCode || "";
        this.form.whtAcctName = wht?.acctName || "";


        // console.log("expense:: ", expense);

        const normalizedForm = Object.entries(defaultBlank).reduce(
          (acc, [key, defaultValue]) => ({
            ...acc,
            [key]: this.form[key] || defaultValue,
          }),
          {}
        );

        await this.updateVendorDefault();

        // Use mock values instead of form values
        const mockLineTotalNum = Number(this.mockLineTotal) || 0;
        const mockTaxAmountNum = Number(this.mockTaxAmount) || 0;

        const whtAmount =
          Number( (mockLineTotalNum * Number(this.form.whtRate)) / 100 ).toFixed(2) ||
          Number("0.00");

        // Calculate gross price from mock values
        const grossPrice = (mockLineTotalNum + mockTaxAmountNum)?.toFixed(2) || "0.00";

          // console.log("docline:: ", this.docline);
        // console.log("whtAmount:: ", whtAmount, typeof whtAmount);

        this.$emit("save", {
          ...this.docline,
          ...normalizedForm,
          taxAmount: mockTaxAmountNum,
          grossPrice: Number(grossPrice),
          whtAmount: Number(whtAmount),
          whtRate: Number(this.form.whtRate),
          lineTotal: mockLineTotalNum,
        });
        this.cancel();
      }
    },
    async updateVendorDefault() {
      try {
        this.isUpdatingVendorDefault = true;

        // console.log("Company: ", this.companyID);
        // console.log("cardCode: ", this.cardCode);

        const vendorRef = fc.db
          .collection(`Companies/${this.companyID}/PurchaseInvoiceVendors`)
          .doc(`${this.cardCode}`);

        const expCode = this.form.expenseCode || "";
        const expData =
          this.expenseList.find((x) => x?.expCode === expCode) || {};
        const vatCode = this.form.taxCode || "";
        const vatData = this.vatList.find((x) => x?.vatCode === vatCode) || {};
        const whtCode = this.form.whtCode || "";
        const whtData = this.whtList.find((x) => x?.whtCode === whtCode) || {};

        const newVendorDefault = {
          [`defaultAcct${vatCode}`]: {
            expCode,
            expData,
            vatCode,
            vatData,
            whtCode,
            whtData,
          },
        };

        // console.log("newVendorDefault::: ", newVendorDefault);

        await vendorRef.set(newVendorDefault, { merge: true });
      } catch (error) {
        console.error("Error updating the refresh field:", error);
      } finally {
        this.isUpdatingVendorDefault = true;
      }
    },
  },
};
</script>
